<div class="font-semibold pb-4">
  <span class="pl-2" style="font-size: 18px">{{ "exportFile.fileTemplate" | translate }}</span>
</div>
<div class="mb-3">
  <p-card>
    <div class=" header">
      <div>
        <span class="header-text" [innerHTML]="'exportFile.directives' | translate"></span>
        <a class="header-text-blue pl-1" target="_blank" [href]="getLink(true)">{{
          'exportFile.tutoLink' | translate
          }}</a>
      </div>
      <div>
        <span class="header-text">{{'exportFile.directivesExtra' | translate}}</span>
        <a class="header-text-blue pl-1 pr-1" target="_blank"  [href]="getLink(false)" [innerHTML]="'exportFile.directiveButton' | translate">
        </a>
        <span class="header-text">{{'exportFile.additionalText' | translate}}</span>
      </div>
    </div>
  </p-card>
</div>
<p-card>
  <div class=" header mb-3">
    <span class="header-text"> {{'exportFile.selectDistributionChannel' | translate}}</span>
  </div>
  <div class="grid pb-4 mt-1">
    <div class="col-4">
      <p-select
      optionLabel="channelName"
      [options]="channels"
      [(ngModel)]="selectedChannel"
      (ngModelChange)="onChannelChange($event)"
      class="w-full">
      <ng-template let-option pTemplate="item">
        {{ option.channelName | translate }}
      </ng-template>
      <ng-template let-selectedItem pTemplate="selectedItem">
        @if (selectedItem) {
          <p class="inline line-height-1">{{ "global.distributionChannel" | translate }} -</p>
          <p class="inline font-bold line-height-1">{{' '}}{{selectedItem.channelName | translate}}</p>
        }
      </ng-template>
    </p-select>
    </div>
  </div>
  <div class="mb-3">
    <span class="font-bold"> {{'exportFile.selectMarketLang' | translate}}:</span>
  </div>
  <div class="flex align-content-between">
    <div class="flex-1">
      <div style="width: 300px">
        <p-multiSelect
          [style]="{ width: '100%' }"
          [options]="locales"
          placeholder="{{'exportFile.localSelectionPlaceHolder' | translate }}"
          [(ngModel)]="selectedLocales">
        </p-multiSelect>
      </div>
    </div>
    <div>
      <p-button
        class="mt-4"
        label="{{ 'exportFile.generateCtalogImportFile' | translate }}"
        (onClick)="downloadTemplate()"
        [disabled]="selectedLocales.length == 0 || selectedCategories.length == 0"
        [loading]="downloading">
      </p-button>
    </div>
  </div>
</p-card>

<div class="mt-3">
  <p-card class="relative">
  <div class="header mb-5">
    <div class="header-text" [innerHTML]="'exportFile.selectCategoriesDetail' | translate"></div>
  </div>
    <div class="grid">
      <div class="md:col-7 sm:col-12">
        <div class="pl-3 flex align-content-between">
          <span class="font-bold flex-1"> {{'exportFile.selectCategory' | translate}}:</span>
          @if (selectedCategories.length > 0) {
            <span class="pr-3">
              <p-tag [severity]="leavesSelected > 100 ? 'danger' : 'info'">
                {{ leavesSelected + " " }}{{'exportFile.selected' |translate}}
              </p-tag>
            </span>
          }
        </div>
  
        <div>
          <div style="height: 70vh">
            <p-tree
              emptyMessage="{{ 'primeng.emptyMessage' | translate }}"
              [scrollHeight]="'60vh'"
              [value]="categories"
              [filter]="true"
              [loading]="loading"
              filterBy="categoryLabelLoc"
              selectionMode="checkbox"
              (onNodeSelect)="onNodeSelect($event)"
              (onNodeUnselect)="onNodeUnselect($event)"
              [(selection)]="selectedCategories">
              <ng-template let-node pTemplate="default">
                <div>
                  <span class="p-ml-2">{{ node.categoryLabelLoc }}</span>
                </div>
              </ng-template>
            </p-tree>
          </div>
        </div>
      </div>
  
      <div class="md:col-5 sm:col-12">
        <div class="pl-3 flex">
          <span class="font-bold flex-1"> {{'exportFile.selectedCategories' | translate}}</span>
        </div>
        <div style="height: 70vh">
          <p-tree
            emptyMessage="{{ 'primeng.emptyMessage' | translate }}"
            [filter]="true"
            filterBy="categoryLabelLoc"
            [scrollHeight]="'60vh'"
            selectionMode="checkbox"
            (onNodeUnselect)="onNodeUnselect($event)"
            [value]="selections"
            [(selection)]="selectedCategories">
            <ng-template let-node pTemplate="default">
              <div class="flex align-content-center">
                <div class="flex-1 p-ml-2">{{ node.categoryBreadcrumbLoc }}</div>
              </div>
            </ng-template>
          </p-tree>
        </div>
      </div>
    </div>
  </p-card>
</div>
<p-toast></p-toast>
